module.exports = __webpack_public_path__ + "static/ExtendIT-Slider3-123967c48a612d3c823d1c2e7a0f9667.jpg";